<template>
    <div class="col-lg-12 synoptic-div">
        <vue-synoptic
            :image-url="widget.attributes.imgS3Key != undefined ? widget.attributes.imgS3Key.attributeValue: ''"
            :synopticId="id"
            @onSynopticClick="onSynopticClick"
            @onMarkerClick="onMarkerClick"
            @onMarkerChanged="onMarkerChanged"
            @onSynopticLoad="onSynopticLoad"
            :markers="markers"
            :options="options"
        />

        <overlay :enabled="loading"></overlay>
    </div>
</template>

<script>
import moment from 'moment'
import notificator from '@/mixins/notificator';

import VueSynoptic from '../VueSynoptic'
import Overlay from '@/components/Overlay.vue';

export default {
    props: ['id', 'widget'],

    components: {VueSynoptic, Overlay},
    
    mixins: [notificator],

    data() {
        return {
            options: {
                doubleClickZoom: true,
                zoomRange: [0, 1]
            },
            // markers: [{x: 362, y: -264, title: 'prova', draggable: true}]
            markers: [],

            ready: false,
            loading: false,
            timer: null,
            data: {},
        }
    },

    beforeMount() {
        if(this.widget != undefined && this.widget.attributes.options != undefined) {
            this.options = JSON.parse(this.widget.attributes.options.attributeValue);
        }
    },

    created() {    
        if(this.widget != undefined && this.widget.attributes.markers != undefined)
            this.markers = JSON.parse(this.widget.attributes.markers.attributeValue);
        
        this.start();
    },

    methods: {
        onSynopticClick() {},
        // onSynopticClick({x, y}) {
            // console.log(x,y);
            
            // this.markers.push({ x, y, title: 'prova2'})
        // },
        onMarkerChanged() {},
        // onMarkerChanged(markers) {},
        onSynopticLoad() {},
        // onSynopticLoad(e) {},
        onMarkerClick(marker) {
            if(marker.clickAction != undefined && marker.clickAction == 'selectDashboard')
                this.selectDashboard(marker.departmentId, marker.departmentName, marker.machineId, marker.machineName, marker.deviceId, marker.deviceName)                        
        },

        start() {
            this.getTSData()

            this.timer = setInterval(() => {
                this.getTSData()
            }, 60000);
        },

        generateDevicesQueries() {
            var offset = new Date().getTimezoneOffset();
            
            var aqDatetimeLowerbound = moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';
            var aqDatetimeUpperbound = moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';

            var devicesQueries = [];

            for (let index = 0; index < this.markers.length; index++) {
                devicesQueries.push({
                    'aggregation': {'mode': 'LAST'},
                    'aqDatetimeLowerbound': aqDatetimeLowerbound,
                    'aqDatetimeUpperbound': aqDatetimeUpperbound,
                    'deviceIds': [this.markers[index].deviceId], 
                    'paramIds': [parseInt(this.markers[index].paramId)],
                    'queryId': this.markers[index].slug,
                    'readingType': 'HOT'
                });
            }
            
            return devicesQueries;
        },

        getTSData() {

            if(!this.ready)
                this.overlay(true);

            this.$store
            .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
            .catch(error => {
                if(!this.ready)
                    this.overlay(false);

                this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));

                this.data = {};

                if(!this.ready)
                    this.ready = true;
            })
            .then(({data}) => {
                if(!this.ready)
                    this.overlay(false);

                this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

                if(data != undefined && data.deviceQueriesResponse != undefined ) {
                    
                    for (var index = 0; index < this.markers.length; index++) {
                        if(data.deviceQueriesResponse[this.markers[index]['slug']] != undefined && data.deviceQueriesResponse[this.markers[index]['slug']][0] != undefined) {
                            var tmp = data.deviceQueriesResponse[this.markers[index]['slug']][0];

                            //Salvo l'unità di misura
                            if(tmp['stringUnit'] != undefined)
                                this.$set(this.markers[index], 'unit', tmp['stringUnit']);
                                
                            //Salvo il valore
                            this.$set(this.markers[index], 'value', tmp['stringValue'] != undefined ? tmp['stringValue']: '-');
                            
                            //Salvo l'ultima acquisizione
                            if(tmp['stringTimestamp'] != undefined)
                                this.$set(this.markers[index], 'lastAcquisition', tmp['stringTimestamp']);

                            //Verifica soglie
                            if(tmp['value'] != undefined && tmp['value'] != null && tmp['value'] != '')
                            {
                                if(tmp['value'] > this.markers[index]['thresholds'])
                                    this.$set(this.markers[index], 'classes', 'bg-danger');
                                else if(tmp['value'] < this.markers[index]['thresholds'])
                                    this.$set(this.markers[index], 'classes', 'bg-success');
                                else
                                    this.$set(this.markers[index], 'classes', 'bg-warning');
                            } else {
                                this.$set(this.markers[index], 'classes', 'bg-gray-dark');
                            }  
                        }
                    }       
                } else {
                    this.data = {};
                }

                if(!this.ready)
                    this.ready = true;
            });          
        },

        selectDashboard(departmentId, departmentName, machineId, machineName, deviceId, deviceName) {
            if(departmentId != undefined && machineId != undefined && deviceId != undefined) {
                var selected = {}

                if(departmentId != undefined)
                    selected['department'] = {id: departmentId, name: departmentName}
                
                if(machineId != undefined)
                    selected['machine'] = {id: machineId, name: machineName}
                
                if(deviceId != undefined)
                    selected['device'] = {id: deviceId, name: deviceName}

                this.$store.dispatch('changeMonitorDashboard', selected);  
                
                if(this.$router.currentRoute.name != 'monitor')
                    this.$router.push('monitor')
            }                                  
        },  
       
        overlay(action) {
            this.loading = action;
        }
    },

    beforeDestroy: function(){
        clearInterval(this.timer);
    }
}
</script>

<style>
.synoptic-div {
  margin-bottom: 30px;
}

.marker-container {
    background-color: white;
}
/* Marker */
.rl-synoptic .rl-marker {
  background-color: #fff;
  /* border: 1px solid grey;
  border-radius: 5px; */
  border: unset !important;
  border-radius: unset !important;
  font-family: Rubik;
}
.synoptics-marker .parameter-name {
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.1px;
    text-align: center;    
    color: rgba(0, 0, 0, 0.4);
}
.synoptics-marker .parameter-value {
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.1px;
    text-align: center;    
}
</style>
